const ContentBlock: React.FC = ({ children }) => <div className="content-block">{children}</div>;

export default ContentBlock;
